import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dot", "description"]

  static values = { connected: Boolean }

  connect() {
    let _this = this

    // If the user isn't connected, we wait before fetching the status.
    if (this.connectedValue) {
      return this.updateStatus()
    }

    setTimeout(function() { _this.updateStatus() }, 7000)
  }

  updateStatus() {
    fetch("/status.json")
      .then(response => response.json())
      .then(response => {
        if (!response.hasOwnProperty("status")) {
          // Retro-compatibility: ignore the response if it doesn't contain the "status" key
          return
        }

        if (response.status !== "operational") {
          this.dotTarget.classList.add("is-down")
          this.descriptionTarget.innerHTML = i18n.t("js.uptime_status.incident_in_progress")
          return
        }

        this.dotTarget.classList.remove("is-down")
        this.descriptionTarget.innerHTML = i18n.t("js.uptime_status.all_systems_operational")
      })
  }
}
